<style lang="less" scoped>
@import "./login.less";
</style>

<template>
  <div class="login">
    <div class="login-con">
      <div class="form-con">
        <h1>小说系统版权方平台</h1>
        <Form
          ref="loginForm"
          :model="form"
          :rules="rules"
          @keydown.enter.native="handleSubmit"
        >
          <FormItem prop="userName">
            <Input
              size="large"
              v-model="form.userName"
              placeholder="请输入用户名"
            >
              <span slot="prepend">
                <Icon :size="16" type="ios-person"></Icon>
              </span>
            </Input>
          </FormItem>
          <FormItem prop="password">
            <Input
              size="large"
              type="password"
              v-model="form.password"
              placeholder="请输入密码"
            >
              <span slot="prepend">
                <Icon :size="14" type="md-lock"></Icon>
              </span>
            </Input>
          </FormItem>
          <FormItem prop="code" style="display: flex">
            <div style="display: flex">
              <Input
                size="large"
                style="width: 370px"
                v-model="form.code"
                placeholder="验证码"
              >
              </Input>
              <img
                @click="changeImg"
                :src="'data:image/jpeg;base64,' + codeImg"
                style="
                  width: 100px;
                  height: 40px;
                  margin-left: 30px;
                  cursor: pointer;
                "
                alt=""
              />
            </div>
          </FormItem>
          <FormItem prop="isauto">
            <Checkbox v-model="form.isauto">自动登录</Checkbox>
          </FormItem>
          <FormItem>
            <Button @click="handleSubmit" type="primary" long>登录</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { captchaImage, login } from "@/api/api"; //接口测试
export default {
  data() {
    return {
      form: {
        userName: "",
        password: "",
        isauto: false,
        code: "",
      },
      codeImg: "",
      rules: {
        userName: [
          { required: true, message: "账号不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
      },
    };
  },
  mounted() {
    // milu-lanyue 123456
    this.getData();
  },
  methods: {
    getData() {
      console.log(captchaImage())
      captchaImage().then((res) => {
        if (res.code == 200) {
          this.uuid = res.uuid;
          this.codeImg = res.img;
        }
        console.log(res);
      });
    },
    changeImg() {
      this.getData();
    },
    handleSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          //登录成功
          this.login();
        }
      });
    },
    login() {
      var params = {
        captcha: this.form.code,
        password: this.form.password,
        username: this.form.userName,
        uuid: this.uuid,
      };
      login(params).then((res) => {
        if (res.code == 200) {
          sessionStorage.setItem("token", res.token);
          sessionStorage.setItem("menuPermissions", res.menuPermissions);
          if (res.menuPermissions) {
            var permiss = res.menuPermissions.split(",");//根据权限判断菜单
            if (permiss.indexOf("1") > -1) {
              this.$router.push({
                //跳转到汇总统计
                path: "/index/summary",
              });
            } else if (
              permiss.indexOf("1") == -1 &&
              permiss.indexOf("2") > -1
            ) {
              this.$router.push({
                //跳转到小说统计
                path: "/index/FictionStatistics",
              });
            } else if (
              permiss.indexOf("1") == -1 &&
              permiss.indexOf("2") == -1 &&
              permiss.indexOf("3") > -1
            ) {
              this.$router.push({
                //跳转到分成记录
                path: "/index/RechargeRecord",
              });
            }
          }else{
             sessionStorage.removeItem('token')
          }
        } else {
          this.$Message.error(res.msg);
          this.getData();
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/login/login.vue